"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConstrictingVolleyAbilityHandler = exports.ConstrictingVolleyActorAbilityFactory = exports.ConstrictingVolleyAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const Random_1 = require("../../utils/Random");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class ConstrictingVolleyAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.ConstrictingVolley;
        this.__typeName = "ConstrictingVolley";
    }
}
exports.ConstrictingVolleyAbilityArgs = ConstrictingVolleyAbilityArgs;
let ConstrictingVolleyActorAbilityFactory = class ConstrictingVolleyActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("ConstrictingVolley", "AllEnemies", 3);
    }
};
ConstrictingVolleyActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("ConstrictingVolley")
], ConstrictingVolleyActorAbilityFactory);
exports.ConstrictingVolleyActorAbilityFactory = ConstrictingVolleyActorAbilityFactory;
let ConstrictingVolleyAbilityHandler = class ConstrictingVolleyAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const targets = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies);
        container.applyMultiAttack({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "ranged",
            attackerId: ability.invokerId,
            targets: targets.map((targetId, i) => ({
                targetId,
                jitter: (0, Random_1.random)(25, 75),
                damages: [
                    AbilityDamage_1.AbilityDamage.Power("Physical", 80)
                ],
                effects: [
                    {
                        targetId,
                        duration: Duration_1.Duration.Turns(3),
                        effect: new core_1.LinkedEffectsEffectArgs([
                            new core_1.VulnerabilityEffectArgs((0, Random_1.random)(2, 8)),
                            new core_1.BleedingEffectArgs("Power", 10),
                        ], true),
                    }
                ]
            }))
        });
    }
};
ConstrictingVolleyAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.ConstrictingVolley)
], ConstrictingVolleyAbilityHandler);
exports.ConstrictingVolleyAbilityHandler = ConstrictingVolleyAbilityHandler;
